import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import { useGetLegalConsent } from './api/getLegalConsent';
import LegalConsentAcceptanceModal from './LegalConsentAcceptanceModal';

import Sidebar from '../main/Sidebar/Sidebar';

const RequestLegalConsent = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const getLegalConsentQuery = useGetLegalConsent({});

  useEffect(() => {
    dispatch({ type: 'COMMON_UPDATE_SIDEPANEL_STATUS', status: 'icon-only' });
  }, []);

  useEffect(() => {
    if (!getLegalConsentQuery.data) {
      return;
    }

    if (
      getLegalConsentQuery.data.consents.termsAndConditions &&
      getLegalConsentQuery.data.consents.privacyPolicy
    ) {
      window.location.href = '/';
    }
  }, [getLegalConsentQuery.data]);

  if (!getLegalConsentQuery.data) {
    return null;
  }

  return (
    <div className="tw-h-screen tw-flex">
      <Sidebar history={history} isShowAccounts={false} />
      <LegalConsentAcceptanceModal />
    </div>
  );
};

export default RequestLegalConsent;
